module.exports = __webpack_public_path__ + "img/education-explore.1e47775d.jpg";